// extracted by mini-css-extract-plugin
export var alertIcon = "_o6-0";